package com.essntl.features.message.data.repository

import com.essntl.features.message.domain.model.MessageModel
import com.essntl.features.message.domain.model.WhapiChatModel
import com.essntl.features.message.domain.model.WhapiMessageModel
import com.essntl.features.message.domain.repository.MessageRepository

class MessageMockRepository : MessageRepository {
    private val messages = listOf(
        // First Conversation Messages
        WhapiMessageModel(
            id = "0001",
            text = "Hello",
            chatId = "001",
            fromMe = false,
            fromName = "Michael Lee",
            from = "",
            timestamp = 1721293427,
            type = WhapiMessageModel.Type.Text,
            action = null,
            linkPreviewModel = null,
            status = WhapiMessageModel.Status.Read,
            source = "api",
        ),
        WhapiMessageModel(
            id = "0002",
            chatId = "001",
            fromMe = false,
            fromName = "Michael Lee",
            from = "",
            timestamp = 1721293427,
            text = "I would like to clarify the details of the service.",
            type = WhapiMessageModel.Type.Text,
            action = null,
            linkPreviewModel = null,
            status = WhapiMessageModel.Status.Read,
            source = "api",
        ),

        // Second Conversation Messages
        WhapiMessageModel(
            id = "0003",
            chatId = "002",
            fromMe = true,
            fromName = "Mary Harvey",
            from = "",
            timestamp = 1721293427,
            text = "Dear Mrs. Harvey, tomorrow, Wednesday",
            type = WhapiMessageModel.Type.Text,
            action = null,
            linkPreviewModel = null,
            status = WhapiMessageModel.Status.Read,
            source = "api",
        ),

        // third Conversation Messages
        WhapiMessageModel(
            id = "0004",
            chatId = "003",
            fromMe = false,
            fromName = "Nancy Noelene",
            from = "",
            timestamp = 1721293427,
            text = "I would like to clarify the details of the service",
            type = WhapiMessageModel.Type.Text,
            action = null,
            linkPreviewModel = null,
            status = WhapiMessageModel.Status.Read,
            source = "api",
        ),
        WhapiMessageModel(
            id = "0005",
            chatId = "003",
            fromMe = true,
            fromName = "Nancy Noelene",
            from = "",
            timestamp = 1721293427,
            text = "Dear Mrs. Sami Daik,\n" +
                "\n" +
                "Tomorrow, Wednesday, May, 22nd\n" +
                "\n" +
                "At Aura Hotels your staying for 3 days is confirmed. \n" +
                "For additional info please contact \n" +
                "☎\uFE0F +1 (717) 550-1675",
            type = WhapiMessageModel.Type.Text,
            action = null,
            linkPreviewModel = null,
            status = WhapiMessageModel.Status.Read,
            source = "api",
        ),
        WhapiMessageModel(
            id = "0006",
            chatId = "003",
            fromMe = false,
            fromName = "Nancy Noelene",
            from = "",
            timestamp = 1721293427,
            text = "Thank you",
            type = WhapiMessageModel.Type.Text,
            action = null,
            linkPreviewModel = null,
            status = WhapiMessageModel.Status.Read,
            source = "api",
        ),

        // Fourth Conversation Messages
        WhapiMessageModel(
            id = "0007",
            chatId = "004",
            fromMe = true,
            fromName = "Elaine Williams",
            from = "",
            timestamp = 1721293427,
            text = "Dear Mrs. Williams, tomorrow, Wednesday",
            type = WhapiMessageModel.Type.Text,
            action = null,
            linkPreviewModel = null,
            status = WhapiMessageModel.Status.Read,
            source = "api",
        ),
    )

    override suspend fun sendMessage(message: MessageModel): Result<String> {
        TODO("Not yet implemented")
    }

    override suspend fun getMessagesByItineraryServiceId(id: String): Result<List<MessageModel>> {
        TODO("Not yet implemented")
    }

    override suspend fun getWhapiChatMessages(chatId: String): Result<List<WhapiMessageModel>> {
        return Result.success(messages.filter { it.chatId == chatId })
    }

    override suspend fun sendWhapiTextMessages(text: String, to: String): Result<WhapiMessageModel> {
        TODO("Not yet implemented")
    }

    override suspend fun getWhapiMessageById(whapiId: String): Result<WhapiMessageModel> {
        return Result.success(messages.first { it.id == whapiId })
    }

    override suspend fun insertMessage(message: MessageModel): Result<MessageModel> {
        TODO("Not yet implemented")
    }

    override suspend fun getMessagesByWhapiIds(whapiIds: Set<String>): Result<List<MessageModel>> {
        TODO("Not yet implemented")
    }

    override suspend fun reactToMessage(messageId: String, emoji: String): Result<Unit> {
        TODO("Not yet implemented")
    }

    override suspend fun checkContact(contactId: String): Result<Unit> {
        TODO("Not yet implemented")
    }

    override suspend fun sendContact(to: String): Result<Unit> {
        TODO("Not yet implemented")
    }

    override suspend fun createGroup(subject: String, phoneNumbers: List<String>): Result<WhapiChatModel> {
        TODO("Not yet implemented")
    }

    override suspend fun updateGroupDescription(groupId: String, description: String): Result<Unit> {
        TODO("Not yet implemented")
    }

    override suspend fun addContactToGroup(groupId: String, participants: Set<String>): Result<Unit> {
        TODO("Not yet implemented")
    }

    override suspend fun removeContactFromGroup(groupId: String, participants: Set<String>): Result<Unit> {
        TODO("Not yet implemented")
    }
}